import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Button from "@/components/common/Button";
import {
  facebookCallbackAsync,
  googleCallbackAsync,
  xCallbackAsync,
  selectSocialAuthError,
} from "@/store/redux/slices/auth/auth_slice";
import { FaFacebook, FaGoogle, FaWindows } from "@/config/react_icons";
import { openPopupWindow } from "@/utils/oauth";
import { BASE_URL } from "@/config/api";

const OAuthButtons = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const socialAuthError = useSelector(selectSocialAuthError);

  const handleGoogleLogin = () => {
    const popup = openPopupWindow(`${BASE_URL}/v1/auth/google`, "googleAuth");
    pollOAuthPopup(popup, googleCallbackAsync);
  };

  const handleFacebookLogin = () => {
    const popup = openPopupWindow(
      `${BASE_URL}/v1/auth/facebook`,
      "facebookAuth"
    );
    pollOAuthPopup(popup, facebookCallbackAsync);
  };

  const handleXLogin = () => {
    const popup = openPopupWindow(`${BASE_URL}/v1/auth/x`, "xAuth");
    pollOAuthPopup(popup, xCallbackAsync);
  };

  const pollOAuthPopup = (popup, callbackAction) => {
    const pollTimer = setInterval(() => {
      try {
        if (popup.closed) {
          clearInterval(pollTimer);
          return;
        }

        const popupUrl = popup.location.href;
        if (popupUrl.includes("/callback")) {
          clearInterval(pollTimer);
          popup.close();

          dispatch(callbackAction())
            .unwrap()
            .then(() => {
              navigate("/dashboard");
            })
            .catch((error) => {
              console.error("Failed to complete authentication:", error);
            });
        }
      } catch (error) {
        if (!error.message.includes("cross-origin")) {
          console.error(error);
        }
      }
    }, 500);
  };

  return (
    <div className="flex justify-between gap-3">
      <Button
        icon={<FaFacebook />}
        color="primary"
        className="flex-1 h-11 preserve-bg-primary rounded-[5px] p-2.5"
        isActive={true}
        onClick={handleFacebookLogin}
      />
      <Button
        icon={<FaGoogle />}
        color="danger"
        className="flex-1 h-11 preserve-bg-danger rounded-[5px] p-2.5"
        isActive={true}
        onClick={handleGoogleLogin}
      />
      <Button
        icon={<FaWindows />}
        color="warning"
        className="flex-1 h-11 bg-warning rounded-[5px] p-2.5"
        isActive={true}
        onClick={handleXLogin}
      />

      {socialAuthError && (
        <p className="text-danger mt-2 text-sm">{socialAuthError}</p>
      )}
    </div>
  );
};

export default OAuthButtons;
